import React from 'react';
import { RecordLink } from '../../../components/generic/ListNavigation';
import { EyeIcon, PencilIcon, TrashIcon } from '../../../components/ui';

type ModuleRoutes = {
  detail: (id: number) => string;
  edit: (id: number) => string;
};

/** Shared view / edit / delete row actions for PMS list pages. */
export const PmsTableActions = <T extends { id: number }>({
  item,
  routes,
  onDelete,
  canDelete = true,
  canEdit = true,
}: {
  item: T;
  routes: ModuleRoutes;
  onDelete: (id: number) => void;
  canDelete?: boolean;
  canEdit?: boolean;
}): React.ReactElement => (
  <div className="flex items-center flex-nowrap">
    <RecordLink
      to={routes.detail(item.id)}
      className="p-1 text-indigo-600 hover:text-indigo-900 hover:bg-indigo-50 rounded-lg transition-colors"
      onClick={(e) => e.stopPropagation()}
      title="View"
      aria-label="View"
    >
      <EyeIcon className="w-5 h-5" />
    </RecordLink>
    {canEdit && (
      <RecordLink
        to={routes.edit(item.id)}
        className="p-1 text-blue-600 hover:text-blue-900 hover:bg-blue-50 rounded-lg transition-colors"
        onClick={(e) => e.stopPropagation()}
        title="Edit"
        aria-label="Edit"
      >
        <PencilIcon className="w-5 h-5" />
      </RecordLink>
    )}
    {canDelete && (
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(item.id);
        }}
        className="p-1 text-red-600 hover:text-red-900 hover:bg-red-50 rounded-lg transition-colors"
        title="Delete"
        aria-label="Delete"
      >
        <TrashIcon className="w-5 h-5" />
      </button>
    )}
  </div>
);

export const createPmsGetTableActions = <T extends { id: number }>(routes: ModuleRoutes) => (
  item: T,
  onDelete: (id: number) => void,
  _c?: unknown,
  _ctx?: unknown,
  actionOptions?: { canDelete?: boolean; canEdit?: boolean },
): React.ReactNode => (
  <PmsTableActions
    item={item}
    routes={routes}
    onDelete={onDelete}
    canDelete={actionOptions?.canDelete !== false}
    canEdit={actionOptions?.canEdit !== false}
  />
);
